const ENParametersConfig = {
	"Inserir parâmetro":"Add Parameter",
	"Grupo de parâmetros excluído com sucesso":"Parameter group successfully deleted",
	"Erro ao excluir grupo de prâmetros":"Error on delete parameter group",
	"Erro ao buscar grupos de parâmetros":"Error on search parameter group",
	"Grupo de parâmetros adicionado com sucesso":"Parameter group successfully added",
	"Grupo de parâmetros alterado com sucesso":"Parameter group successfully changed",
	"Erro ao adicionar parâmetro":"Error on add parameter",
	"Erro ao alterar parâmetro":"Error on change parameter",
	"Grupos de parâmetros":"Parameters groups",
	"Reordenar grupos":"Reorder groups",
	"Adicionar grupo de parâmetro":"Add parameter group",
	"Alterar grupo de parâmetro":"Change parameter group",
	"Parâmetro adicionado com sucesso":"Parameter successfully added",
	"Parâmetro alterado com sucesso":"Parameter successfully changed",
	"Erro ao adicionar grupo de parâmetros":"Error on add parameter group",
	"Erro ao alterar grupo de parâmetros":"Error on change parameter group",
	"Erro ao buscar parâmetro":"Error on search parameter",
	"Adicionar parâmetro":"Add parameter",
	"Alterar parâmetro":"Change parameter",
	"O campo parâmetro é numérico":"The parameter field is numeric",
	"Parâmetro é requerido":"Parameter is required",
	"O tipo é requerido":"Type is required",
	"O tipo é inválido":"Type is invalid",
	"Valor é requerido":"Value is required",
	"Configurar parâmetros":"Parameters settings",
	"Ao menos uma opção deve ser informada":"At least one option must be informed",
	"Nova opção":"New Option",
	"Exclusão de Parâmetro":"Delete Parameter",
	"Exclusão de grupo":"Delete Group",
	"Deseja realmente excluir o parâmetro":"Do you really want to delete the parameter",
	"Parâmetro excluído com sucesso":"Parameter successfully deleted",
	"Reordenar grupos de parâmetros":"Reorder parameter groups"
};

export default ENParametersConfig;
